import { IBaseCard } from "./base-card.interface";
import { ComputedCard, CosmosEntity } from "./card-basics.interface";

export interface TaxprepT1Card extends CosmosEntity, ComputedCard {
    id: string;
    cardId: string;
    dashboardId: string;
    return: {
        id: string;
        type: string; // "Taxpayer" | "Spouse" | "Dependant"
        statusId: string;
        statusDate: number;
        statusUserId: string;
    };
    filePath: string;
    categoryId: string | null;
    officeId: string | null;
    group1Id: string | null;
    group2Id: string | null;
    roleUserMapping: Array<{
        roleId: string;
        userId: string | null;
    }>;
    isSplit?: boolean;
    isVIP: boolean;
    inAlertAt: number | null;
    inDangerAt: number | null;
    name: string;
    contactInformation: {
        firstName: string;
        lastName: string;
        phone: string;
        cellPhone: string;
        email: string;
        iFirmContactId?: string;
    };
    lastYearDocumentsReceivedDate: number | null;
    documentsReceivedDate: number | null;
    lastYearCompletedDate: number | null;
    deadLine: number | null;
    quiet: number | null;
    paymentDate: number | null;
    taxYearEndDate: number | null;
    groupName: string | null;
    note: string | null;
    temporaryNote: string | null;
    clientCodes: {
        clientCodePIN: string | null;
        clientCodeId: string | null;
        clientCodeiFirm: string | null;
    };
    statusesHistory: Array<{
        statusId: string;
        statusDate: number;
        userId: string;
    }>;
    lastYearStatusesHistory: Array<{
        statusId: string;
        statusDate: number;
        userId: string;
    }>;
    efileStatuses: {
        fedEfileStatus: number;
        provEfileStatus: number;
        t1135EfileStatus: number;
        rC4649EfileStatus: number;
        aT1EfileStatus: number;
    };
    members: Array<{
        cardId: string;
    }>;
    tags: string[];
    originalId: string | null;
    applyStatusToAll: boolean | null;
    applyAssigneesToAll: boolean | null;
    dateNeeded: number | null;
    deliveryMethod: string | null;
}

export function isTaxprepT1Card(card: IBaseCard): card is TaxprepT1Card {
    return "return" in card && card.return != null && typeof (card as any).return.id !== "undefined";
}

export type CardId = string;
export type CardsByCardIdMap = Map<CardId, IBaseCard>;
